/** Refresh the id_token when fewer than this many ms remain before expiry. */
export const TOKEN_REFRESH_BUFFER_MS = 15 * 60 * 1000;
